export type AnalysisType =
	| 'social_network_analysis'
	| 'ai_interview_analysis'
	| 'mobility_platform_analysis'
	| 'default_score_analysis';

export interface InputVariable {
	name: string;
	type: string;
	range?: string;
	values?: string[];
	description: string;
	source: string;
	conditional?: string;
}

export interface InputSchema {
	description: string;
	source: string;
	structure: string;
	fields?: string[];
	variables?: InputVariable[];
}

export interface OutputSchemaField {
	type: string;
	range?: string;
	description: string;
	conditional?: string;
	values?: string[];
}

export interface AnalysisConfiguration {
	id: string;
	organization_id: string;
	analysis_type: AnalysisType;
	instructions: string;
	input_schema: InputSchema | null;
	output_schema: Record<string, OutputSchemaField> | null;
	created_at: string;
	updated_at: string;
}

export const ANALYSIS_TYPE_LABELS: Record<AnalysisType, string> = {
	social_network_analysis: 'Social Network Analysis',
	ai_interview_analysis: 'AI Interview Analysis',
	mobility_platform_analysis: 'Mobility Platform Analysis',
	default_score_analysis: 'Default Score Analysis'
};
